import helper from './helper'

const getMailUrlWithParameters = helper.getMailUrlWithParameters

export default {
  getMailUrlWithParameters,
  /**
   * Базовая функция для построения урл
   */
  getByRecievedUrlData: (url, gets = null) => getMailUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  MAIL: {
    MAIL_LIST:
      /**
       * Получает список почтовых сообщений пользователя
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения списка почтовых сообщений
       */
      (gets = null) => getMailUrlWithParameters(
        'inside_email|catalog',
        'get',
        null,
        gets
      )
  }
}
